module.exports = __webpack_public_path__ + "static-portal/img/al-1.6732d3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/al-1.jpg
// module id = RH+a
// module chunks = 4